import { render, staticRenderFns } from "./DocumentsList.vue?vue&type=template&id=2a15459b&scoped=true&"
import script from "./DocumentsList.vue?vue&type=script&lang=js&"
export * from "./DocumentsList.vue?vue&type=script&lang=js&"
import style0 from "../../assets/scss/documents_list.scss?vue&type=style&index=0&id=2a15459b&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a15459b",
  null
  
)

export default component.exports